import React, { useState, Fragment } from 'react';
import styles from './seasonal-cities.module.scss';
import { dataConvertOverview } from '../../utils/overall-convert';
import { seasonalCitiesOverview } from "../../data/data-seasonal-cities";
import { formatNumberWithDot } from '../../utils/utils';
import CountryFlag from '../common/countryFlag/country-flag';
import SelectDropdown from '../common/selectDropdown/select-dropdown';
import IconSort from '../common/icon/icon-sort';
import ReverseIconSort from '../common/icon/reverse-icon-sort';

const options = [
  { label: "Residents + second home owners", value: "secondhome" },
  { label: "Residents", value: "residents" }
];

const SeasonalCities = () => {

  const [sortColumn, setSortColumn] = useState("secondhome");
  // const [display, setDisplay] = useState();
  const [countryCount, setCountryCount] = useState(1);
  const [secondhomeCount, setSecondhomeCount] = useState(1);
  const [residentsCount, setResidentsCount] = useState(1);
  const [numOfCitiesShow, setNumOfCitiesShow] = useState(10);
  const [hideList, setHideList] = useState(true);

  const handleOptionSelect = (option) => {
    // setSelectedOption(option);
    setSortColumn(option.value);
    // setDisplay(-1);
  };

  // const missingCountry = seasonalCitiesOverview.map((item) => (
  //   item.country, 
  //   countryCode[item.country]
  // ));
  // console.log(missingCountry)

  const dataSeasonalOverview = () => { 
    return dataConvertOverview(seasonalCitiesOverview);
  }
  
  const handleSort = (columnName) => {
    switch (columnName) {
      case 'country':
        (countryCount === 1) ? setCountryCount(-1) : setCountryCount(1);
        break;
      case 'secondhome':
        (secondhomeCount === 1) ? setSecondhomeCount(-1) : setSecondhomeCount(1);
        break;
      case 'residents':
        (residentsCount === 1) ? setResidentsCount(-1) : setResidentsCount(1);
        break;
      default:
        break;
    }
    
    setSortColumn(columnName);
    // setDisplay(-1);
  };

  const reverseSortNum = (columnName, count) => {
    if (count === 1) {
      return dataSeasonalOverview().sort((a, b) => b[columnName] - a[columnName]);
    }
    return dataSeasonalOverview().sort((a, b) => a[columnName] - b[columnName]);
  }
  

  const handleSortingOptions = (columnName) => {
    switch (columnName) {
      case 'country':
        return (countryCount === 1) ?
         dataSeasonalOverview().sort((a, b) => b[columnName].localeCompare(a[columnName]))
        : dataSeasonalOverview().sort((a, b) => a[columnName].localeCompare(b[columnName]));
      case 'secondhome':
        return reverseSortNum(columnName, secondhomeCount);
      case 'residents':
        return reverseSortNum(columnName, residentsCount);
      default:
        break;
    }

  }

  const sortedData = sortColumn
    ? handleSortingOptions(sortColumn)
    : dataSeasonalOverview();

  // const handleMobileRowClick = (index) => {
  //   setDisplay(index);
  // }

  const handleShowHideList = () => {
    setHideList(!hideList);
    setNumOfCitiesShow(numOfCitiesShow === 10 ? `${sortedData.length}` : 10);
  };


  return (
    <>
      <h3 className="mb-5">Cities and Regions with Big Seasonal Variations of Centi-Millionaires</h3>
      <div className={`d-md-none ${styles.sortMobileWrapper}`}>
        <div className={styles.sortTitle}>Sort by</div>
        <SelectDropdown options={options} onSelect={handleOptionSelect} />
      </div>
      <table className={`chartTable ${styles.overviewChartTable}`}>
        <thead>
          <tr>
            <td style={{ 'border': 'None' }}></td>
            <td className={styles.cellHideMobile} style={{ 'border': 'None' }}></td>
            <th colSpan="2" className={`text-center`} style={{ 'border': 'None' }}>
              <span>Centi-millionaires (USD 100m+)</span>
            </th>
            {/* <td className={styles.cellHideMobile} style={{ 'border': 'None' }}></td> */}
          </tr>

          <tr>
            <th className={styles.cityColumn} width="25%">Cities and regions with notable seasonal<br />variations in centi-millionaires</th>
            <th
              className={`text-left ${styles.cellHideMobile}  ${styles.sortableColumn} ${sortColumn === 'country' ? styles.selectedColumn : ''}`}
              width="25%"
              onClick={() => handleSort("country")}
            >
              <div className={styles.sortColumnTitle}>
                {(countryCount === 1) ? <IconSort /> : <ReverseIconSort />}
                <span className={styles.sortColumnTitleText}>Country</span>
              </div>
            </th>

            <th
              className={
                `text-right 
                              ${styles.cellHideMobile}  
                              ${styles.sortableColumn} 
                              ${sortColumn === 'secondhome' ? styles.selectedColumn : ''}
                              ${sortColumn === 'secondhome' ? styles.displayColumnTitleDiv : ''}
              `}
              onClick={() => handleSort("secondhome")}
            >
              <div className={styles.sortColumnTitle}>
                <span className={styles.sortColumnTitleText}>Residents + second<br />home owners</span>
                {(secondhomeCount === 1) ? <IconSort /> : <ReverseIconSort />}
              </div>
            </th>
            <th
              className={                
                `text-right 
                              ${styles.cellHideMobile}  
                              ${styles.sortableColumn} 
                              ${sortColumn === 'residents' ? styles.selectedColumn : ''}
                              ${sortColumn === 'residents' ? styles.displayColumnTitleDiv : ''}
              `}
              onClick={() => handleSort("residents")}
            >
              <div className={styles.sortColumnTitle}>
                <span className={styles.sortColumnTitleText}>Residents</span>
                {(residentsCount === 1) ? <IconSort /> : <ReverseIconSort />}
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {sortedData.slice(0, numOfCitiesShow).map((item, index) => (
            <Fragment key={index}>
              <tr className={`${styles.contentRow} ${styles.openedRow}`}>
                <td>{item.city}</td>
                <td className={`text-left 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${sortColumn === 'country' ? styles.selectedColumn : ''}
                              `}>
                  <CountryFlag country={item.country} />
                </td>

                <td rowSpan={2} className={`text-right 
                                            ${styles.hiddenTableRow} 
                                            ${styles.sortableColumn} 
                                            ${styles.combinateRowCells} 
                                            ${sortColumn ? styles.selectedColumn : ''} 
                                            ${sortColumn === 'centiGrowth' ? styles.percentColumn : ''}
                                          `}>
                  {formatNumberWithDot(item[sortColumn])}
                </td>
                
                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortColumn === 'secondhome' ? styles.selectedColumn : ''}
                              `}>
                  {formatNumberWithDot(item.secondhome) + "+"}
                </td>
                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortColumn === 'residents' ? styles.selectedColumn : ''}
                              `}>
                  {formatNumberWithDot(item.residents)}
                </td>
                
              </tr>
              <tr className={`${styles.hiddenTableRow}`}>
                <td className={`${styles.countryMobileDiv}`}>
                  <CountryFlag country={item.country} />
                </td>
              </tr>

            </Fragment>
          ))}
          
          <tr>
            <td className={`${styles.bufferBeforeTotal} `}
                style={{ borderBottom: 0 }}
            ></td>
            <td className={`${styles.cellHideMobile} 
                            ${styles.bufferBeforeTotal}`} 
                style={{ borderBottom: 0 }}
            ></td>
            <td className={`${styles.cellHideMobile} 
                            ${styles.bufferBeforeTotal}`} 
                style={{ borderBottom: 0 }}
              ></td>
            <td className={`${styles.cellHideMobile} 
                            ${styles.bufferBeforeTotal}`} 
                style={{ borderBottom: 0 }}
              ></td>

          </tr>
          
          
          <tr>
            <td className={`${styles.bufferBeforeTotal}`}
                style={{ borderBottom: 0 }}
            ></td>
            <td className={`${styles.cellHideMobile} 
                            ${styles.bufferBeforeTotal}`} 
                style={{ borderBottom: 0 }}
            ></td>
            <td className={`${styles.bufferBeforeTotal}`} 
                style={{ borderBottom: 0 }}
              >
                <div className={styles.showButton} style={{ paddingTop: "20px" }}>
                  <button className={styles.collapseButton} onClick={handleShowHideList}>
                    {hideList ? `Show All ${sortedData.length} Cities` : "Collapse list"}
                  </button>
                </div>
              </td>
            <td className={`${styles.cellHideMobile} 
                            ${styles.bufferBeforeTotal}`} 
                style={{ borderBottom: 0 }}
              ></td>
            <td className={`${styles.cellHideMobile} 
                            ${styles.bufferBeforeTotal}`} 
                style={{ borderBottom: 0 }}
            ></td>
          </tr>
          
        
        </tbody>
      </table>

      <div className="footer-note mt-5">
        <ul>
          <li>'Centi-millionaires' refers to individuals with investable wealth of USD 100 million or more.</li>
          <li>Figures for June 2023.</li>
        </ul>
        <p>Source: New World Wealth</p>
      </div>
    </>
  )
}

export default SeasonalCities;